<template>
    <v-flex>
        <v-card v-show="!isChampsView || !manageSponsorMode" class="custom-dailog">
            <v-card-title v-if="!isChampsView">
                {{ sponsorsConstants.MANAGE_SPONSORS }}
                <i class="fas fa-times" @click="cancel()" data-qe-id="close_dialog_btn"></i>
            </v-card-title>

            <v-card-text class="sponsor-dialog inner-scrollbar">
                <status-bar :action="submitAction"></status-bar>
                <v-layout row class="sponsor-dialog__cont">
                    <div class="sponsor__layoutview">
                        <grid-layout
                            :layout.sync="gridItems"
                            :col-num="NUM_COLUMNS"
                            :row-height="125"
                            :margin="[30, 30]"
                            :is-draggable="true"
                            :is-resizable="false"
                            :vertical-compact="false"
                            :auto-size="true">
                            <grid-item
                                v-for="(gridItem, i) in gridItems"
                                :key="gridItem.id"
                                :x="gridItem.x"
                                :y="gridItem.y"
                                :w="gridItem.w"
                                :h="gridItem.h"
                                :i="gridItem.sponsorItem.id">
                                <v-btn
                                    color="white"
                                    fab
                                    small
                                    @click="manageSponsor(sponsorsConstants.manageSponsorMode.edit, replaceItem, i, gridItem.sponsorItem)"
                                    :data-qe-id="`sponsor-dialog_item_${i}_edit_btn`"
                                    id="manageSponsor"
                                    class="sponsor-dialog__icon-button sponsor-dialog__icon-button-edit">
                                    <v-icon color="black">edit</v-icon>
                                </v-btn>
                                <div class="sponsor-dialog__img-wrapper">
                                    <v-img
                                        :src="gridItem.sponsorItem.logo.url"
                                        contain
                                        class="item-border"> </v-img>
                                </div>
                                <delete-sponsor-dialog
                                    v-if="!isChampsView"
                                    @confirm="deleteItem($event)"
                                    :data="gridItem.sponsorItem">
                                    <v-btn
                                        slot="activator"
                                        color="white"
                                        fab
                                        small
                                        :data-qe-id="`sponsor-dialog_item_${i}_close_btn`"
                                        class="sponsor-dialog__icon-button sponsor-dialog__icon-button-close">
                                        <v-icon color="black" mouseover>close</v-icon>
                                    </v-btn>
                                </delete-sponsor-dialog>
                                <v-btn
                                    v-else
                                    @click="deleteItem(gridItem.sponsorItem)"
                                    color="white"
                                    fab
                                    small
                                    :data-qe-id="`sponsor-dialog_item_${i}_close_btn`"
                                    class="sponsor-dialog__icon-button sponsor-dialog__icon-button-close">
                                    <v-icon color="black" mouseover>close</v-icon>
                                </v-btn>
                            </grid-item>
                        </grid-layout>
                    </div>
                    <div class="sponsor-dialog__cont__btn">
                        <v-btn
                            v-if="!limitReached"
                            @click="manageSponsor(sponsorsConstants.manageSponsorMode.add, addItem, -1, null)"
                            medium
                            data-qe-id="sponsor-dialog_add-new_btn"
                            class="sponsor-dialog__add-button">
                            <v-icon size="100" color="#bbb">add</v-icon>
                        </v-btn>
                        <v-btn
                            v-if="limitReached"
                            medium
                            :disabled="true"
                            data-qe-id="sponsor-dialog_add-post-limit_btn"
                            class="sponsor-dialog__add-button">
                            <v-icon size="100" color="#bbb">add</v-icon>
                        </v-btn>
                        <p
                            v-if="limitReached"
                            class="sponsor-dialog__add-button-message"
                            data-qe-id="sponsor-dialog_limit-reached_message">
                            {{ sponsorsConstants.ADD_BUTTON_LIMIT }}
                        </p>
                    </div>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-flex text-xs-right class="pa-3">
                    <v-btn
                        class="primary_btn transparent"
                        @click="cancel()"
                        data-qe-id="sponsor-dialog_cancel_btn"
                        id="cancel_unittest">
                        {{ sponsorsConstants.CANCEL }}
                    </v-btn>
                    <v-btn
                        class="primary_btn"
                        @click="save()"
                        data-qe-id="sponsor-dialog_apply_btn"
                        id="save_unittest">{{ sponsorsConstants.APPLY }}
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
        <add-sponsor-dialog-content
            v-if="isChampsView && (manageSponsorMode === sponsorsConstants.manageSponsorMode.add || manageSponsorMode === sponsorsConstants.manageSponsorMode.edit)"
            :show-title="false"
            :current-editing-sponsor-index="currentEditingSponsorIndex"
            :item="currentEditingSponsorItem"
            :save-call-back="manageSponsorSaveCallBack"
            :cancel-call-back="cancelManageSponsor" />
        <v-dialog
            v-show="!isChampsView && addSponsorDialogOpen"
            v-model="addSponsorDialogOpen"
            lazy
            absolute
            scrollable
            content-class="medium">
            <add-sponsor-dialog-content
                v-if="!isChampsView && addSponsorDialogOpen"
                :current-editing-sponsor-index="currentEditingSponsorIndex"
                :item="currentEditingSponsorItem"
                :save-call-back="manageSponsorSaveCallBack"
                :cancel-call-back="() => {addSponsorDialogOpen = false}"></add-sponsor-dialog-content>
        </v-dialog>
    </v-flex>
</template>

<script>
    import VueGridLayout from 'vue-grid-layout';
    import { communityCommonConstant } from '@/components/ChapterPage/communityCommon.constant';
    import AddSponsorDialogContent from "./AddSponsorDialogContent";
    import DeleteSponsorDialog from "./DeleteSponsorDialog";
    import StatusBar from "../../StatusBar/StatusBar";
    import sponsorsConstants from "./sponsors.constant";
    import { jsonClone, getRandomId } from "../../../common/utils/utils";
    import { mapState } from 'vuex';

    const NUM_COLUMNS = 8;

    function reflowGridItems(gridItems) {
        let x = 0;
        let y = 0;
        gridItems.forEach((item) => {
            const width = item.w;
            if (x + width > NUM_COLUMNS) {
                y += 1;
                x = 0;
            }
            item.x = x;
            item.y = y;
            x += width;
        });
    }

    export default {
        name: 'SponsorDialogContent',
        components: {
            VueGridLayout,
            AddSponsorDialogContent,
            DeleteSponsorDialog,
            StatusBar,
        },
        data: () => ({
            NUM_COLUMNS,
            communityCommonConstant,
            sponsorsConstants,
            items: [],
            manageSponsorMode: null,
            manageSponsorSaveCallBack: null,
            currentEditingSponsorIndex: -1,
            currentEditingSponsorItem: null,
            gridItems: [],
            addSponsorDialogOpen: false,
        }),
        props: {
            closeCallBack: {
                type: Function,
                required: true,
            },
            communityId: {
                type: String,
                required: true,
            },
            sponsors: {
                type: Array,
                required: true,
            },
            saveactionname: {
                type: String,
                required: true,
            },
            saveactionmodulename: {
                type: String,
                required: true,
            },
            isChampsView: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            this.items = this.sponsors.map((x) => {
                return {
                    ...x,
                    id: x.id || getRandomId(),
                    isIdTemporary: !x.id,
                };
            });
        },
        watch: {
            items() {
                this.gridItems = this.items.map(sponsorItem => ({
                    x: 0,
                    y: 0,
                    w: sponsorItem.w,
                    h: sponsorItem.h,
                    i: sponsorItem.id,
                    sponsorItem,
                }));
                reflowGridItems(this.gridItems);
            },
        },
        methods: {
            manageSponsor(mode, saveCallBack, index, item) {
                this.manageSponsorMode = null;
                this.currentEditingSponsorIndex = index;
                this.currentEditingSponsorItem = item;
                this.manageSponsorSaveCallBack = saveCallBack;
                if (!this.isChampsView) {
                    this.addSponsorDialogOpen = true;
                }
                setTimeout(() => {
                    this.manageSponsorMode = mode;
                }, 0);
            },
            reSortItems() {
                const gridItems = this.gridItems.slice();
                gridItems.sort((a, b) => a.x - b.x);
                gridItems.sort((a, b) => a.y - b.y);
                this.items = gridItems.map(gridItem => gridItem.sponsorItem);
            },
            addItem(item) {
                this.reSortItems();
                item.isIdTemporary = true;
                this.items = this.items.concat([item]);
                this.manageSponsorMode = null;
                this.addSponsorDialogOpen = false;
            },
            deleteItem(item) {
                this.reSortItems();
                this.items = this.items.filter(x => x.id !== item.id);
                this.manageSponsorMode = null;
            },
            replaceItem(newItem, index) {
                this.reSortItems();
                this.items = this.items.map((x, i) => (i === index ? newItem : x));
                this.manageSponsorMode = null;
                this.addSponsorDialogOpen = false;
            },
            cancelManageSponsor() {
                this.manageSponsorMode = null;
            },
            cancel() {
                this.closeCallBack();
                this.manageSponsorMode = null;
            },
            save() {
                this.reSortItems();

                const itemsToSave = this.items.map((item, i) => {
                    const itemToSave = jsonClone(item);
                    itemToSave.sponsorOrder = i + 1;
                    if (itemToSave.isIdTemporary) {
                        delete itemToSave.id;
                        delete itemToSave.isIdTemporary;
                    }
                    return itemToSave;
                });

                this.$store.dispatch(`${this.saveactionmodulename}/${this.saveactionname}`, { communityId: this.communityId, data: itemsToSave }).then(() => {
                    this.closeCallBack();
                });
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            limitReached() {
                const used = this.items.reduce((total, item) => {
                    return total + item.w * item.h;
                }, 0);
                return used >= sponsorsConstants.MAX_LOGO_UNITS;
            },
            submitAction() {
                return this.actions[this.saveactionname];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .item-border {
        border: 1px solid $ypo-gray !important;
        border-radius: 10px;
        width: 100%;
        height: 100%;
    }

    .responsive {
        width: 125px;
        height: 125px;
    }

    .sponsor__layoutview {
        border: none;
        width: 1000px;
        overflow-y: scroll;
        text-align: center;
    }

    .sponsor-dialog {
        &__add-button {
            margin-left: 60px;
            width: 125px;
            height: 125px;
            margin-top: 30px;
        }

        &__cont {
            @include breakpoint(md) {
                display: block;

                .sponsor__layoutview {
                    width: 100%;
                    overflow: inherit;
                }

                &__btn {
                    .sponsor-dialog__add-button {
                        width: auto;
                        height: auto;
                        padding: 5px 10px;
                        margin: 0 30px;
                        background: $ypo-blue !important;

                        i {
                            font-size: 40px !important;
                            color: $white !important;
                        }
                    }
                }
            }

            @include breakpoint(xs) {
                .sponsor__layoutview {
                    width: inherit;
                }

                .vue-grid-layout {
                    width: 1300px;
                }

                &__btn {
                    .sponsor-dialog__add-button {
                        i {
                            font-size: 34px !important;
                        }
                    }
                }
            }
        }

        &__close-btn .v-icon {
            min-height: 30px !important;
            min-width: 30px !important;
            font-weight: bold !important;
        }

        &__apply_btn {
            border: 1px solid $ypo-gray !important;
            border-radius: 4px;
            background-color: $ypo-title-blue !important;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            font-size: 14.44px !important;
            font-weight: bold !important;
            letter-spacing: 1.25px !important;
        }

        &__popupclose_btn {
            border-radius: 4px !important;
            color: $ypo-gray-text !important;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            font-size: 15.44px !important;
            font-weight: 600 !important;
            letter-spacing: 1.25px !important;
            line-height: 16px !important;
            text-align: center !important;
        }

        &__icon-button {
            position: absolute;
            z-index: 100;

            &-edit {
                top: -20px;
                right: -30px;
            }

            &-close {
                left: -30px;
                bottom: -20px;
            }

            &-add {
                position: relative !important;
            }
        }

        &__img-wrapper {
            position: absolute;
            top: 0;
            height: 100%;
            width: 100%;
        }

        &__order-buttom {
            margin-left: 80px;
        }

        &__add-button-message {
            margin-left: 50px;
            color: $ypo-gold;
        }

        @include breakpoint(md) {
            .v-card {
                max-width: 1600px;
                width: 1600px;
            }
        }
        @include breakpoint(xs) {
            overflow-x: auto;
        }
    }

    /* grid layout */
    /********************************/
    .vue-grid-layout {
        background: $white;
        width: 100%;
    }

    .vue-resizable-handle {
        z-index: 5001;
        position: relative;
        width: 20px;
        height: 20px;
        bottom: 0;
        right: 0;
        background-position: bottom right;
        padding: 0 3px 3px 0;
        background-repeat: no-repeat;
        background-origin: content-box;
        box-sizing: border-box;
        cursor: se-resize;
    }

    .vue-grid-item:not(.vue-grid-placeholder) {
        background: $white;
        border: 1px solid $white;
    }

    .vue-grid-item.resizing {
        opacity: 0.9;
    }

    .vue-grid-item.static {
        background: $white;
    }

    .vue-grid-item .add {
        cursor: pointer;
    }
</style>
